import React from "react";

// Components
import Intro from "../../components/Intro/intro";
import Skills from "../../components/Skills/skills";
import Works from "../../components/Portfolio/Portfolio";
import Contact from "../../components/Contact/contact";
import Footer from "../../components/Footer/footer";
import ITTimeline from "../../components/ITTimeline/ITTimeline";
import About from "../../components/About/About";
import WhoIsThisFor from "../../components/WhoIsThisFor/WhoIsThisFor";

// Optional components kept disabled for now.
// import ScrollToTop from "../../components/ScrollToTop/ScrollToTop";
// import ProcessFlow from "../../components/ProcessFlow/ProcessFlow";
// import SocialProof from "../../components/SocialProof/SocialProof";

export default function Home({ lang, prefix }) {
  return (
    <>
      <Intro lang={lang} />

      <div className="mx-auto w-full px-0 md:max-w-7xl md:px-6 lg:px-8">
        <About lang={lang} />
        <WhoIsThisFor lang={lang} prefix={prefix} />
        <ITTimeline lang={lang} />
        <Skills lang={lang} />
        <Works lang={lang} />
        <Contact lang={lang} />
        <Footer lang={lang} prefix={prefix} />
      </div>

      {/*
      <ScrollToTop />
      */}
    </>
  );
}